export default "__VITE_ASSET__D7gLNd3___"